import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ViewService } from 'src/app/services/view.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent {
  constructor(
    public viewService: ViewService,
    private authService: AuthService
  ) {}

  get signedIn() {
    return this.authService.signedIn;
  }

  get isAdmin() {
    return this.authService.isAdmin();
  }

  get canAccessPricing() {
    return this.authService.canAccessPricing();
  }

  get isActivationKeysAdmin() {
    return this.authService.isActivationKeysAdmin();
  }

  get isRegistrationDbAdmin() {
    return this.authService.isRegistrationDbAdmin();
  }

  get isSuperAdmin() {
    return this.authService.isSuperAdmin();
  }

  get showApiInvoices() {
    return this.authService.hasApiSubscription;
  }

  get year() {
    return new Date().getFullYear();
  }

  switchView(type: 'user' | 'admin') {
    this.viewService.setView(type);
  }

  openConsentPreferences() {
    const consentPreferencesLink = document.getElementById(
      'termly-display-preferences-link'
    );
    if (consentPreferencesLink) {
      consentPreferencesLink.click();
    }
  }
}
